var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star 50",
    d: "M9.77121 0.146484L10.5461 3.665C10.8718 5.14356 12.0043 6.31155 13.4721 6.68265L16.6127 7.47669L13.4721 8.27073C12.0043 8.64183 10.8718 9.80982 10.5461 11.2884L9.77121 14.8069L8.9963 11.2884C8.67066 9.80982 7.53816 8.64183 6.07036 8.27073L2.92969 7.47669L6.07036 6.68265C7.53816 6.31155 8.67066 5.14356 8.9963 3.66501L9.77121 0.146484Z",
    fill: "#780EFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 51",
    d: "M3.32303 8.94141L3.67352 10.4267C3.84753 11.1642 4.42331 11.7399 5.16073 11.9139L6.64605 12.2644L5.16073 12.6149C4.42331 12.7889 3.84753 13.3647 3.67352 14.1021L3.32303 15.5875L2.97254 14.1021C2.79853 13.3647 2.22274 12.7889 1.48532 12.6149L0 12.2644L1.48532 11.9139C2.22274 11.7399 2.79852 11.1642 2.97254 10.4267L3.32303 8.94141Z",
    fill: "#780EFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 52",
    d: "M3.32303 0L3.67352 1.48532C3.84753 2.22274 4.42331 2.79852 5.16073 2.97254L6.64605 3.32303L5.16073 3.67352C4.42331 3.84753 3.84753 4.42331 3.67352 5.16073L3.32303 6.64605L2.97254 5.16073C2.79853 4.42331 2.22274 3.84753 1.48532 3.67352L0 3.32303L1.48532 2.97254C2.22274 2.79853 2.79852 2.22275 2.97254 1.48532L3.32303 0Z",
    fill: "#780EFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiStar);
export default __webpack_public_path__ + "static/media/ai-star.139a47701b5bbb35f6ea45ff8abddd4d.svg";
export { ForwardRef as ReactComponent };